export default __webpack_public_path__ + "static/media/fphand.bd601e3e.ico";